import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGeneralErrorSmall = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 135,
	height: 90,
	viewBox: "0 0 135 90",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M0 49.786C-1.80441e-05 57.882 6.80837 77.2161 21.5357 85.7203C36.5734 94.4036 49.1811 87.1382 66.9146 87.4247C80.3089 87.641 88.5628 91.4817 101.218 87.4247C119.124 81.6843 138.552 71.8427 134.445 54.7572C131.588 42.8754 117.987 43.0682 109.525 33.7364C101.083 24.4272 101.988 14.8164 91.5269 7.46039C68.8816 -8.46278 41.2638 3.46805 20.1513 21.0955C9.42369 30.0523 1.80442e-05 41.6901 0 49.786Z",
			fill: "#FFF2F5",
			fillOpacity: .5
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 71,
			cy: 23,
			r: 15,
			stroke: "#F29FB2",
			strokeWidth: .430991,
			strokeLinecap: "round",
			strokeDasharray: "1.72 2.59"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 25.5,
			cy: 24.5,
			rx: 25.5,
			ry: 24.5,
			transform: "matrix(-1 0 0 1 63 32)",
			stroke: "#F29FB2",
			strokeWidth: .430991,
			strokeLinecap: "round",
			strokeDasharray: "1.72 2.59"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 105,
			cy: 59.5,
			rx: 10,
			ry: 10.5,
			stroke: "#F2A2B5",
			strokeWidth: .430991,
			strokeLinecap: "round",
			strokeDasharray: "1.72 2.59"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 40.774,
			y: 18.7832,
			width: 4.60709,
			height: .915426,
			transform: "rotate(-45 40.774 18.7832)",
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 98.0999,
			y: 34.8232,
			width: 4.60709,
			height: .915426,
			transform: "rotate(-45 98.0999 34.8232)",
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 34.4714,
			y: 75.3384,
			width: 4.60709,
			height: .915426,
			transform: "rotate(-45 34.4714 75.3384)",
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 120.377,
			y: 69.5752,
			width: 4.60709,
			height: .915426,
			transform: "rotate(-45 120.377 69.5752)",
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 41.3855,
			y: 15.4453,
			width: 4.76445,
			height: .979898,
			transform: "rotate(45 41.3855 15.4453)",
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 98.7113,
			y: 31.4849,
			width: 4.76445,
			height: .979898,
			transform: "rotate(45 98.7113 31.4849)",
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 35.0829,
			y: 72,
			width: 4.76445,
			height: .979898,
			transform: "rotate(45 35.0829 72)",
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 120.988,
			y: 66.2368,
			width: 4.76445,
			height: .979898,
			transform: "rotate(45 120.988 66.2368)",
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.6562 21.9561C28.6966 22.0593 30.3193 23.7465 30.3193 25.8125L30.3145 26.0107C30.2112 28.0511 28.524 29.6738 26.458 29.6738L26.2598 29.6689C24.2851 29.5691 22.7015 27.9854 22.6016 26.0107L22.5967 25.8125C22.5967 23.6799 24.3255 21.9512 26.458 21.9512L26.6562 21.9561ZM25.1025 27.959C25.4951 28.2073 25.9591 28.3535 26.458 28.3535C27.8614 28.3535 28.9989 27.2159 28.999 25.8125C28.999 25.3136 28.8528 24.8496 28.6045 24.457L25.1025 27.959ZM26.458 23.2715C25.0545 23.2715 23.917 24.409 23.917 25.8125C23.917 26.3358 24.0746 26.8224 24.3457 27.2266L27.8721 23.7002C27.4679 23.4291 26.9813 23.2715 26.458 23.2715Z",
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M74.7539 73.9277C76.7943 74.0309 78.417 75.7181 78.417 77.7842L78.4121 77.9824C78.3088 80.0227 76.6216 81.6455 74.5557 81.6455L74.3574 81.6406C72.3829 81.5406 70.7992 79.957 70.6992 77.9824L70.6943 77.7842C70.6943 75.6517 72.4232 73.923 74.5557 73.9229L74.7539 73.9277ZM73.2002 79.9307C73.5927 80.179 74.0567 80.3251 74.5557 80.3252C75.9591 80.3252 77.0965 79.1876 77.0967 77.7842C77.0967 77.2852 76.9505 76.8213 76.7021 76.4287L73.2002 79.9307ZM74.5557 75.2432C73.1522 75.2433 72.0146 76.3807 72.0146 77.7842C72.0147 78.3073 72.1734 78.7932 72.4443 79.1973L75.9697 75.6719C75.5656 75.4008 75.0789 75.2432 74.5557 75.2432Z",
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M89.5102 13.4207C89.45 13.2098 89.6083 13 89.8275 13H92.9525C93.1718 13 93.3301 13.2098 93.2698 13.4207L91.7073 18.8894C91.6161 19.2086 91.1639 19.2086 91.0727 18.8894L89.5102 13.4207Z",
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.5102 51.4207C23.45 51.2098 23.6083 51 23.8275 51H26.9525C27.1718 51 27.3301 51.2098 27.2698 51.4207L25.7073 56.8894C25.6161 57.2086 25.1639 57.2086 25.0727 56.8894L23.5102 51.4207Z",
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 91.39,
			cy: 21,
			r: 1,
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 25.39,
			cy: 59,
			r: 1,
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter0_dd_5649_529)",
			children: [/* @__PURE__ */ _jsx("rect", {
				x: 38,
				y: 26,
				width: 57,
				height: 41,
				rx: 1.32,
				fill: "white"
			}), /* @__PURE__ */ _jsx("rect", {
				x: 37.67,
				y: 25.67,
				width: 57.66,
				height: 41.66,
				rx: 1.65,
				stroke: "#F39BB1",
				strokeWidth: .66
			})]
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: .5,
			cy: .5,
			r: .5,
			transform: "matrix(1 0 0 -1 41 29)",
			fill: "#EF476F"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: .5,
			cy: .5,
			r: .5,
			transform: "matrix(1 0 0 -1 43 29)",
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: .5,
			cy: .5,
			r: .5,
			transform: "matrix(1 0 0 -1 45 29)",
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 49.165,
			y1: 28.5352,
			x2: 84.835,
			y2: 28.5352,
			stroke: "#F39DB2",
			strokeWidth: .33,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 54.495,
			y1: 62.505,
			x2: 78.505,
			y2: 62.505,
			stroke: "#FFCAD7",
			strokeWidth: .99,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 60.495,
			y1: 64.505,
			x2: 73.505,
			y2: 64.505,
			stroke: "#FFCAD7",
			strokeWidth: .99,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M69.6901 36.5025L69.7985 36.6829L78.9967 53.117C79.2725 53.6097 79.4167 54.1593 79.4167 54.7174C79.4167 56.5321 77.9242 58.0156 76.0422 58.1192L75.8315 58.125H57.1693C56.5676 58.125 55.9756 57.9811 55.4479 57.7065C53.7753 56.8364 53.1224 54.8839 53.9252 53.2663L54.0243 53.0813L63.4883 36.6472C63.8241 36.0641 64.332 35.5871 64.9494 35.2749C66.6328 34.4237 68.7083 34.9768 69.6901 36.5025ZM66.6614 51.1913C66.0014 51.1913 65.4663 51.6999 65.4663 52.3272C65.4663 52.9545 66.0014 53.4631 66.6614 53.4631C67.3214 53.4631 67.8565 52.9545 67.8565 52.3272C67.8565 51.6999 67.3214 51.1913 66.6614 51.1913ZM66.6614 42.1043C66.0485 42.1043 65.5434 42.488 65.4744 42.9823L65.4663 43.0982V49.0615L65.4744 49.1775C65.5434 49.6718 66.0485 50.0554 66.6614 50.0554C67.2743 50.0554 67.7794 49.6718 67.8484 49.1775L67.8565 49.0615V43.0982L67.8484 42.9823C67.7794 42.488 67.2743 42.1043 66.6614 42.1043Z",
			fill: "#EF476F"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
			id: "filter0_dd_5649_529",
			x: 28.1,
			y: 24.0198,
			width: 76.8001,
			height: 60.8003,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feMorphology", {
					radius: 1.32,
					operator: "dilate",
					in: "SourceAlpha",
					result: "effect1_dropShadow_5649_529"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 7.92 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 3.96 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "out"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.937255 0 0 0 0 0.278431 0 0 0 0 0.435294 0 0 0 0.05 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_5649_529"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 2.64 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.32 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "out"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.937255 0 0 0 0 0.278431 0 0 0 0 0.435294 0 0 0 0.05 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "effect1_dropShadow_5649_529",
					result: "effect2_dropShadow_5649_529"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect2_dropShadow_5649_529",
					result: "shape"
				})
			]
		}) })
	]
});
const ForwardRef = forwardRef(SvgGeneralErrorSmall);
export { ForwardRef as ReactComponent };
